/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PostWithdrawalSecretsMutationRequest,
  PostWithdrawalSecretsMutationResponse,
  PostWithdrawalSecrets400,
  PostWithdrawalSecrets403,
} from '../entities/PostWithdrawalSecrets'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { postWithdrawalSecrets } from '../api/postWithdrawalSecrets'
import { useMutation } from '@tanstack/react-query'

export const postWithdrawalSecretsMutationKey = () => [{ url: '/withdrawal-secrets' }] as const

export type PostWithdrawalSecretsMutationKey = ReturnType<typeof postWithdrawalSecretsMutationKey>

/**
 * @description Создание api-ключа вывода средств для таксопарка
 * @summary Создание api-ключа вывода средств для таксопарка
 * {@link /withdrawal-secrets}
 */
export function usePostWithdrawalSecrets<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostWithdrawalSecretsMutationResponse,
      ResponseErrorConfig<PostWithdrawalSecrets400 | PostWithdrawalSecrets403>,
      { data: PostWithdrawalSecretsMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<PostWithdrawalSecretsMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? postWithdrawalSecretsMutationKey()

  return useMutation<
    PostWithdrawalSecretsMutationResponse,
    ResponseErrorConfig<PostWithdrawalSecrets400 | PostWithdrawalSecrets403>,
    { data: PostWithdrawalSecretsMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postWithdrawalSecrets(data, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}